import { get } from './';
import * as Api from './v2';

export const getContact = ({ queryKey }) =>
  Api.get(`/v1/contacts/${queryKey?.[1]}`, { params: queryKey?.[2] });
export const getContactConversations = id =>
  get(`/v1/contacts/${id}/conversations`);
export const getContactByEmailAddress = email =>
  get(`/v1/users?email=${email}`);
export const getContractsInvitationsByEmailAddress = ({ email, placeId }) =>
  get(`/v1/contract_invitations?by_place=${placeId}&invited_email=${email}`);
export const getContractsInvitationsByContactId = ({ placeId, contactId }) =>
  get(
    `/v1/contract_invitations?by_place=${placeId}&invited_contact_id=${contactId}`,
  );
